module.exports = __webpack_public_path__ + "img/hx-ydhyy.4dec2750.svg";